import script from "./FilterItems.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterItems.vue?vue&type=script&setup=true&lang=js"

import "./FilterItems.vue?vue&type=style&index=0&id=785c1923&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-785c1923"]])

export default __exports__